module.exports = __webpack_public_path__ + "img/c05_unitstartechcenturionchampion_Normal_ua.6d1c3b68.webp";